import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, Row, Col } from 'reactstrap';
import './SupplierDatabase.scss';

class SupplierDatabase extends React.Component { // eslint-disable-line react/prefer-stateless-function
    static propTypes = {};

    static defaultProps = {};

    render() {
        return (
            <div className="supplier-database-page">
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>NFFS ICON - Supplier Database</title>
                </Helmet>

                <Container className="content-container mt-5 mb-5">
                    <Row>
                        <Col>
                            <h1 className="page-title mb-4">Supplier Database</h1>
                            <div className="content-box p-4">
                                <h2>Supplier Capabilities Database</h2>
                                <p className="lead">
                                    Foundries, forgers and machine shops can leverage the ICON Supplier Capabilities Database to identify potential new suppliers, partners or customers interested in supporting the defense sector. Also, users can highlight their own operations and capabilities to connect with potential customers or partners.
                                </p>
                                <hr />
                                <h3>Key features:</h3>
                                <ul>
                                    <li>Create a customizable profile that highlights your operational strengths and identifies key manufacturing processes, materials capabilities</li>
                                    <li>Search and connect directly with potential partners or suppliers through the ICON platform</li>
                                    <li>Identify industry relationships, such as membership in manufacturing trade associations</li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default SupplierDatabase; 


// WEBPACK FOOTER //
// ./src/pages/static/SupplierDatabase/SupplierDatabase.jsx